<template>
  <div>
    <div
      v-if="rejectMessage"
      class="col-12 alert alert-danger fade show px-3"
      role="alert"
    >
      <h1 class="text-center mt-2">{{ rejectMessage }}</h1>
    </div>
    <form class="mt-3" @submit.prevent="login">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="card bg-light">
              <div class="card-body">
                <h3 class="font-weight-light mb-3">Log in</h3>
                <section class="form-group">
                  <div class="col-12 alert alert-danger px-3" v-if="error">
                    {{ error }}
                  </div>
                  <label class="form-control-label sr-only" for="Email"
                    >Email</label
                  >
                  <input
                    class="form-control"
                    v-bind:class="validEmailState()"
                    type="email"
                    id="email"
                    placeholder="Email Address"
                    required
                    v-model="email"
                  />
                  <div class="invalid-feedback">{{ invalidFB.email }}</div>
                </section>
                <section class="form-group">
                  <input
                    class="form-control"
                    v-bind:class="validPasswordState()"
                    type="password"
                    required
                    placeholder="Password"
                    v-model="password"
                  />
                  <div class="invalid-feedback">{{ invalidFB.password }}</div>
                </section>
                <div class="form-group text-right mb-0">
                  <button class="btn btn-primary" type="submit">Log in</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <p class="text-center mt-2">
      <span>
        <router-link to="/register">register</router-link>
        or
        <router-link to="/forgotpassword">forgot password?</router-link>
        or
        <a
          href="mailto:admin@olabbio.com?subject=Required Action: Forgot Password"
          >admin</a
        >
        for assistance
      </span>
    </p>
  </div>
</template>
<script>
import firebase from "firebase";
import { OlabUtils } from "../olab/olabutils.js";

export default {
  data: function() {
    return {
      email: "",
      password: "",
      error: "",
      wrongEmail: false,
      wrongPassword: false,
      invalidFB: {
        email: "User email not found.",
        password:
          "Wrong password. Try again or click forgot password to reset it."
      }
    };
  },
  props: ["rejectMessage"],
  methods: {
    validEmailState: function() {
      let result = null;
      result = this.wrongEmail ? "is-invalid" : null;
      return result;
    },
    validPasswordState: function() {
      let result = null;
      result = this.wrongPassword ? "is-invalid" : null;
      return result;
    },
    login: function() {
      const info = {
        email: this.email,
        password: this.password
      };

      firebase
        .auth()
        .signInWithEmailAndPassword(info.email, info.password)
        .then(userCredentials => {
          OlabUtils.infoLog("user = " + userCredentials.user);
          OlabUtils.infoLog("user uid = " + userCredentials.user.uid);

          firebase
            .auth()
            .setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .then(function() {
              OlabUtils.infoLog(
                "Login: setPersistence(firebase.auth.Auth.Persistence.SESSION)"
              );
              // Existing and future Auth states are now persisted
              // in the current session only. Closing the window
              // would clear any existing state even if a user forgets
              // to sign out.
              // ...
              // New sign-in will be persisted with session persistence.
              return firebase
                .auth()
                .signInWithEmailAndPassword(info.email, info.password);
            })
            .catch(
              function(error) {
                // Handle Errors here.
                this.error = error.code + ": " + error.message;
              }.bind(this)
            );

          this.$router.push("/");
        })
        .catch(
          function(error) {
            if (error.code.toLowerCase().match("wrong-password")) {
              this.wrongPassword = true;
              this.invalidFB.password =
                "Wrong password. Try again or click forgot password to reset it.";
            } else if (error.code.toLowerCase().match("too-many-requests")) {
              this.wrongPassword = true;
              this.invalidFB.password =
                "Too many unsuccessful login attempts. Try again later or click forgot password to reset it.";
            } else if (error.code.toLowerCase().match("user-not-found")) {
              this.wrongEmail = true;
              this.invalidFB.email = "User email not found.";
            } else if (error.code.toLowerCase().match("user-disabled")) {
              this.wrongEmail = true;
              this.invalidFB.email =
                "User email has been disabled. Please contact admin if this is a mistake";
            } else {
              this.error = error.code + ": " + error.message;
            }
          }.bind(this)
        );
    }
  },
  watch: {
    email: function() {
      // OlabUtils.infoLog("email = " + this.email);
      // Reset
      if (this.wrongEmail) {
        this.wrongEmail = false;
      }
    },
    password: function() {
      // OlabUtils.infoLog("password = " + this.password);
      // Reset
      if (this.wrongPassword) {
        this.wrongPassword = false;
      }
    },
    error: function() {
      // Reset
      if (this.error) {
        setTimeout(() => {
          this.error = null;
        }, 5000);
      }
    }
  }
};
</script>
